(function () {
  // ─── Styles ───────────────────────────────────────────────────────────────
  (function injectTooltipStyles() {
    if (document.getElementById('stock-tooltip-style')) return;
    const style = document.createElement('style');
    style.id = 'stock-tooltip-style';
    style.textContent = `
      .quantity-loading {
        position: relative;
        pointer-events: none;
        opacity: 0.6;
      }
      .quantity-loading::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        margin-top: -8px;
        margin-left: -8px;
        border: 2px solid #000;
        border-top-color: transparent;
        border-radius: 50%;
        animation: quantitySpinner 0.6s linear infinite;
      }
      @keyframes quantitySpinner {
        to { transform: rotate(360deg); }
      }

      .stock-tooltip {
        display: none;
        align-items: flex-start;
        gap: 8px;
        background: #FFEDED;
        border: 1px solid #D11D1D4D;
        padding: 5px 12px;
        margin-top: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #D41818;
        line-height: 1.4;
        box-sizing: border-box;
        width: 100%;
      }
      .stock-tooltip.visible { display: flex; }
      .stock-tooltip__icon {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        margin-top: 1px;
      }
      .stock-tooltip__text { flex: 1; }

      /* Checkout loader banner */
      #checkout-stock-loader {
        display: none;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        padding: 10px 12px;
        background: #fff0f0;
        border: 1px solid #D41818;
        border-radius: 4px;
        font-size: 12px;
        color: #D41818;
      }
      #checkout-stock-loader .spinner {
        width: 14px;
        height: 14px;
        border: 2px solid #D41818;
        border-top-color: transparent;
        border-radius: 50%;
        animation: quantitySpinner 0.6s linear infinite;
        flex-shrink: 0;
      }
    `;
    document.head.appendChild(style);
  })();

  // ─── Constants ────────────────────────────────────────────────────────────
  const WARNING_SVG = `<svg class="stock-tooltip__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.4246 20.4983C3.2551 20.4983 3.10285 20.4569 2.96785 20.3741C2.83285 20.2913 2.72794 20.182 2.6531 20.0463C2.5751 19.9117 2.53219 19.7658 2.52435 19.6088C2.51652 19.4518 2.55885 19.2963 2.65135 19.1423L11.2121 4.35434C11.3048 4.20034 11.4206 4.08651 11.5596 4.01284C11.6988 3.93918 11.8453 3.90234 11.9991 3.90234C12.1529 3.90234 12.2994 3.93918 12.4386 4.01284C12.5776 4.08651 12.6934 4.20034 12.7861 4.35434L21.3469 19.1423C21.4394 19.2963 21.4817 19.4518 21.4739 19.6088C21.466 19.7658 21.4231 19.9117 21.3451 20.0463C21.2703 20.182 21.1654 20.2913 21.0304 20.3741C20.8954 20.4569 20.7431 20.4983 20.5736 20.4983H3.4246ZM4.4491 18.9983H19.5491L11.9991 5.99834L4.4491 18.9983ZM11.9994 17.8061C12.2279 17.8061 12.4198 17.7287 12.5746 17.5738C12.7294 17.419 12.8069 17.2272 12.8069 16.9983C12.8069 16.7695 12.7294 16.5777 12.5746 16.4228C12.4198 16.268 12.2279 16.1906 11.9994 16.1906C11.7703 16.1906 11.5784 16.268 11.4236 16.4228C11.2688 16.5777 11.1914 16.7695 11.1914 16.9983C11.1914 17.2272 11.2688 17.419 11.4236 17.5738C11.5784 17.7287 11.7703 17.8061 11.9994 17.8061ZM11.9994 15.1906C12.212 15.1906 12.3901 15.1188 12.5336 14.9751C12.6773 14.8313 12.7491 14.6531 12.7491 14.4406V10.9406C12.7491 10.7281 12.6772 10.55 12.5334 10.4063C12.3895 10.2625 12.2114 10.1906 11.9989 10.1906C11.7862 10.1906 11.6081 10.2625 11.4646 10.4063C11.3209 10.55 11.2491 10.7281 11.2491 10.9406V14.4406C11.2491 14.6531 11.321 14.8313 11.4649 14.9751C11.6087 15.1188 11.7869 15.1906 11.9994 15.1906Z" fill="#D41818"/>
  </svg>`;

  // ─── State ────────────────────────────────────────────────────────────────
  let activeRequest = 0;
  const updatingVariants = new Set();
  let _cartCache = null;
  let _cartCacheTs = 0;

  /**
   * Master flag: true while ANY cart quantity sync or checkout validation
   * is in progress. Checkout buttons are disabled whenever this is true.
   */
  let cartOperationInProgress = false;

  // ─── Checkout button lock ─────────────────────────────────────────────────
  function toggleCheckoutButtons(disabled) {
    const buttons = document.querySelectorAll(
      '#checkoutButton, [name="checkout"], .checkout, .cart__checkout-button'
    );
    buttons.forEach(btn => {
      btn.disabled = disabled;
      btn.style.pointerEvents = disabled ? 'none' : 'auto';
      btn.style.opacity = disabled ? '0.5' : '1';
    });
  }

  function beginCartOperation() {
    cartOperationInProgress = true;
    toggleCheckoutButtons(true);
  }

  function endCartOperation() {
    cartOperationInProgress = false;
    toggleCheckoutButtons(false);
  }
  window.addEventListener('pageshow', function () {
    cartOperationInProgress = false;
    hideCheckoutLoader(true);
    const loader =
      document.getElementById(
        'checkout-stock-loader'
      );
  
    if (loader) {
      delete loader.dataset.permanent;
    }
  
    toggleCheckoutButtons(false);
  });

  // ─── Cart cache ───────────────────────────────────────────────────────────
  function invalidateCartCache() {
    _cartCache = null;
    _cartCacheTs = 0;
  }
  async function fetchCartData() {
    const now = Date.now();
    if (_cartCache && now - _cartCacheTs < 300) return _cartCache;
    try {
      const response = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin',
      });
      _cartCache = await response.json();
      _cartCacheTs = Date.now();
      return _cartCache;
    } catch (err) {
      console.error('Failed to fetch cart.js:', err);
      return null;
    }
  }
  async function getCartItem(variantId) {
    const cart = await fetchCartData();
    if (!cart || !cart.items) return null;
    return cart.items.find(i => String(i.variant_id) === String(variantId));
  }

  async function getConfirmedCartQuantity(variantId) {
    const cart = await fetchCartData();
    if (!cart || !cart.items) return 0;
    return cart.items
      .filter(i => String(i.variant_id) === String(variantId))
      .reduce((sum, i) => sum + Number(i.quantity || 0), 0);
  }

  // ─── Cart refresh ─────────────────────────────────────────────────────────
  let isNavigatingToNewPage = false;

  window.addEventListener('beforeunload', () => {
    isNavigatingToNewPage = true;
  });
  
  function triggerCartRefresh() {
    if (isNavigatingToNewPage) return;
  
    if (typeof refreshCartDrawer === 'function') {
      refreshCartDrawer();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }
  async function updateCartDrawerCount() {
    try {
      const cart = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin'
      }).then(r => r.json());
  
      const countElement =
        document.getElementById('cartdrawercount');
  
      if (countElement) {
        countElement.textContent =
          cart.item_count || 0;
      }
  
    } catch (err) {
      console.error(
        'Cart drawer count update failed:',
        err
      );
    }
  }
  async function fetchLiveStock(variantId, options) {
    const settings = Object.assign(
      { allowFallback: true },
      options || {}
    );
  
    try {
      const cart = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin',
      }).then(r => r.json());
  
      const cartItem = cart.items.find(
        item =>
          String(item.variant_id) ===
          String(variantId)
      );
  
      if (!cartItem || !cartItem.url) {
        return {
          variantId,
          stock: 0,
          source: 'fallback',
        };
      }
      const productUrl =
        cartItem.url.split('?')[0];
  
      const fetchUrl =
        `${productUrl}?variant=${variantId}` +
        `&section_id=tm-variant-stock&_=${Date.now()}`;
  
      const response = await fetch(fetchUrl, {
        cache: 'no-store',
        credentials: 'same-origin',
      });
  
      const html = await response.text();
  
      const wrapper = document.createElement('div');
  
      wrapper.innerHTML = html;
  
      const node =
        wrapper.querySelector('#liveStockData');
  
      if (!node) {
        return {
          variantId,
          stock: settings.allowFallback
            ? await getFallbackStock(variantId)
            : 0,
          source: 'fallback',
        };
      }
  
      return {
        variantId,
        stock: Number(
          node.dataset.stock || 0
        ),
        source: 'live',
      };
    } catch (err) {
      console.error(
        'Live stock fetch failed:',
        err
      );
  
      return {
        variantId,
        stock: settings.allowFallback
          ? await getFallbackStock(variantId)
          : 0,
        source: 'fallback',
      };
    }
  }

  // ─── DOM helpers ──────────────────────────────────────────────────────────
  function updateDomQuantity(variantId, newQty) {
    const input = document.querySelector(`#updates_${variantId}`);
    if (input) input.value = newQty;
  }

  function findQuantityWrapper(variantId) {
    const input = document.querySelector(`#updates_${variantId}`);
    if (!input) return null;
    return (
      input.closest('.quantity.border_radius.border-radius-sharp') ||
      input.closest('.quantity_selector_group') ||
      input.closest('.quantity-wrapper') ||
      input.closest('.quantity__wrapper') ||
      input.closest('.qty-wrapper') ||
      input.closest('.quantity') ||
      input.parentElement
    );
  }

  function showQuantityLoader(variantId) {
    const wrapper = findQuantityWrapper(variantId);
    if (wrapper) wrapper.classList.add('quantity-loading');
  }

  function hideQuantityLoader(variantId) {
    const wrapper = findQuantityWrapper(variantId);
    if (wrapper) wrapper.classList.remove('quantity-loading');
  }

  function lockPlusButton(variantId) {
    const plusBtn =
      document.querySelector(`.plus.quantity-selector[data-variant-id="${variantId}"]`) ||
      document.querySelector(`.plus.quantity-selector[onclick*="${variantId}"]`);
    if (!plusBtn) return;
    plusBtn.disabled = true;
    plusBtn.style.opacity = '0.4';
    plusBtn.style.cursor = 'not-allowed';
    plusBtn.style.pointerEvents = 'none';
    plusBtn.style.background = 'transparent';
    plusBtn.style.backgroundColor = 'transparent';
    plusBtn.setAttribute('data-stock-locked', 'true');
  }

  function setPlusButtonState(variantId, stock, cartQty) {
    const plusBtn =
      document.querySelector(`.plus.quantity-selector[data-variant-id="${variantId}"]`) ||
      document.querySelector(`.plus.quantity-selector[onclick*="${variantId}"]`);
    if (!plusBtn) return;
    const shouldDisable = cartQty >= stock;
    plusBtn.disabled = shouldDisable;
    plusBtn.style.opacity = shouldDisable ? '0.4' : '1';
    plusBtn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
    plusBtn.style.pointerEvents = shouldDisable ? 'none' : 'auto';
    plusBtn.style.background = 'transparent';
    plusBtn.style.backgroundColor = 'transparent';
    plusBtn.dataset.liveStock = stock;
    plusBtn.dataset.cartQty = cartQty;
    if (shouldDisable) {
      plusBtn.setAttribute('data-stock-locked', 'true');
    } else {
      plusBtn.removeAttribute('data-stock-locked');
    }
  }

 
  function getOrCreateWarningBox(variantId) {
    let box = document.getElementById(`stock-tooltip-${variantId}`);
    if (box) return box;
  
    const quantityWrapper = findQuantityWrapper(variantId);
    if (!quantityWrapper) return null;
  
    const parent = quantityWrapper.parentElement;
    if (!parent) return null;
  
    if (window.getComputedStyle(parent).display === 'flex') {
      parent.style.flexWrap = 'wrap';
    }
  
    box = document.createElement('div');
    box.id = `stock-tooltip-${variantId}`;
    box.className = 'stock-tooltip';
    box.setAttribute('role', 'alert');
    box.style.width = '100%';
  
    box.innerHTML = `
      ${WARNING_SVG}
      <span class="stock-tooltip__text"></span>
  
      <button type="button" class="stock-tooltip__close" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8242 14.9752C15.8799 15.031 15.9241 15.0971 15.9543 15.17C15.9845 15.2428 16 15.3209 16 15.3997C16 15.4785 15.9845 15.5566 15.9543 15.6294C15.9241 15.7023 15.8799 15.7684 15.8242 15.8242C15.7684 15.8799 15.7023 15.9241 15.6294 15.9543C15.5566 15.9845 15.4785 16 15.3997 16C15.3209 16 15.2428 15.9845 15.17 15.9543C15.0971 15.9241 15.031 15.8799 14.9752 15.8242L10 10.8482L5.02478 15.8242C4.9122 15.9368 4.75951 16 4.6003 16C4.44109 16 4.2884 15.9368 4.17582 15.8242C4.06325 15.7116 4 15.5589 4 15.3997C4 15.2405 4.06325 15.0878 4.17582 14.9752L9.1518 10L4.17582 5.02478C4.06325 4.9122 4 4.75951 4 4.6003C4 4.44109 4.06325 4.2884 4.17582 4.17582C4.2884 4.06325 4.44109 4 4.6003 4C4.75951 4 4.9122 4.06325 5.02478 4.17582L10 9.1518L14.9752 4.17582C15.0878 4.06325 15.2405 4 15.3997 4C15.5589 4 15.7116 4.06325 15.8242 4.17582C15.9368 4.2884 16 4.44109 16 4.6003C16 4.75951 15.9368 4.9122 15.8242 5.02478L10.8482 10L15.8242 14.9752Z" fill="#D11D1D"/>
        </svg>
      </button>
    `;
  
    quantityWrapper.insertAdjacentElement('afterend', box);
  const nearestLi = document.querySelector(`li[data-item-key^="${variantId}"]`);
    
    box.querySelector('.stock-tooltip__close').addEventListener('click', () => {
      box.classList.remove('visible');
      if (nearestLi) {
      nearestLi.classList.remove('stock-warning-box'); // Change to your class
    }
    });
  
    return box;
  }

  function showStockWarning(variantId, stock, cartQty, customMessage = null) {
    const box = getOrCreateWarningBox(variantId);
    if (!box) return;
    const text = box.querySelector('.stock-tooltip__text');
    if (text) {
      text.textContent =
        customMessage ||
        (stock === 0
          ? 'Out of stock.'
          : 'Your cart already contains the maximum available quantity for this variant.');
    }
    box.classList.add('visible');

    // ─── TARGET LI BY DATA-ITEM-KEY ───────────────────────────────
    const nearestLi = document.querySelector(`li[data-item-key^="${variantId}"]`);
    if (nearestLi) {
      nearestLi.classList.add('stock-warning-box'); // Change to your class
    }
    // ──────────────────────────────────────────────────────────────
  }

  function hideStockWarning(variantId) {
    const box = document.getElementById(`stock-tooltip-${variantId}`);
    if (box) box.classList.remove('visible');
  }

  // ─── Checkout loader banner ───────────────────────────────────────────────
  function showCheckoutLoader(
    message,
    permanent = false
  ) {
    let loader =
      document.getElementById(
        'checkout-stock-loader'
      );
  
    if (!loader) {
      loader =
        document.createElement('div');
  
      loader.id =
        'checkout-stock-loader';
  
      loader.innerHTML = `
        <span class="spinner"></span>
        <span class="loader-text"></span>
      `;
  
      const checkoutBtn =
        document.getElementById(
          'checkoutButton'
        ) ||
        document.querySelector(
          '[name="checkout"], .checkout, .cart__checkout-button'
        );
  
      if (checkoutBtn?.parentNode) {
        checkoutBtn.parentNode.insertBefore(
          loader,
          checkoutBtn
        );
      }
    }
  
    // Don't overwrite permanent success
    if (
      loader.dataset.permanent ===
        'true' &&
      !permanent
    ) {
      return;
    }
  
    loader.querySelector(
      '.loader-text'
    ).textContent = message;
  
    loader.style.display = 'flex';
  
    const spinner =
      loader.querySelector(
        '.spinner'
      );
  
    if (spinner) {
      spinner.style.display =
        permanent
          ? 'none'
          : 'block';
    }
  
    if (permanent) {
      loader.dataset.permanent =
        'true';
    }
  }
  function hideCheckoutLoader(force = false) {
    const loader =
      document.getElementById(
        'checkout-stock-loader'
      );
  
    if (!loader) return;
      if (
      loader.dataset.permanent === 'true' &&
      !force
    ) {
      return;
    }
    loader.style.display = 'none';
  }

  // ─── Core cart update ─────────────────────────────────────────────────────
  async function updateCart(variantId, quantity) {
    const item = await getCartItem(variantId);
    if (!item) throw new Error('Cart item not found for variant: ' + variantId);
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.key, quantity }),
    });
    if (response.status === 409) throw new Error('Cart conflict (409)');
    if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
    invalidateCartCache();
    triggerCartRefresh();
    return response.json();
  }

  async function onCartUpdate(variantId, requestedQty) {
    invalidateCartCache();
    const [stockData, confirmedCartQty] = await Promise.all([
      fetchLiveStock(variantId, { allowFallback: true }),
      getConfirmedCartQuantity(variantId),
    ]);
    if (!stockData) return;

    const stock = stockData.stock;
    const safeQty = Math.min(requestedQty, stock);
    updateDomQuantity(variantId, safeQty);
    setPlusButtonState(variantId, stock, safeQty);

    if (safeQty < requestedQty) {
      showStockWarning(variantId, stock, requestedQty);
    } else {
      hideStockWarning(variantId);
    }

    try {
      await updateCart(variantId, safeQty);
    } catch (err) {
      invalidateCartCache();
      await checkStockVsCart(variantId);
      return;
    }

    invalidateCartCache();
    const newConfirmedQty = await getConfirmedCartQuantity(variantId);
    setPlusButtonState(variantId, stock, newConfirmedQty);
    updateDomQuantity(variantId, newConfirmedQty);

    if (newConfirmedQty >= stock) {
      showStockWarning(variantId, stock, newConfirmedQty);
    } else {
      hideStockWarning(variantId);
    }
  }

  // ─── Per-variant stock vs cart check ─────────────────────────────────────
  async function checkStockVsCart(variantId) {
    const [stockData, cart] = await Promise.all([
      fetchLiveStock(variantId, { allowFallback: true }),
      fetchCartData(),
    ]);
    if (!stockData || !cart || !cart.items) return null;

    const stock = Number(stockData.stock || 0);
    const matchingItems = cart.items.filter(i => String(i.variant_id) === String(variantId));
    const cartQty = matchingItems.reduce((sum, i) => sum + Number(i.quantity || 0), 0);

    // Out of stock → remove entirely
    if (stock < 1) {
      let remainingStock = stock;

      for (const item of matchingItems) {
        const allowedQty = Math.min(
          Number(item.quantity || 0),
          remainingStock
        );
      
        remainingStock -= allowedQty;
      
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: item.key,
            quantity: allowedQty,
          }),
        });
      }
      hideQuantityLoader(variantId);
      const box = getOrCreateWarningBox(variantId);
      if (box) {
        const text = box.querySelector('.stock-tooltip__text');
        if (text) text.textContent = 'This variant is no longer available. It has been removed from your cart.';
        box.classList.add('visible');
      }
      triggerCartRefresh();
      return { stock, cartQty: 0, source: stockData.source };
    }

    // Exceeds stock → trim to stock
    if (cartQty > stock) {
      let remainingStock = stock;

      for (const item of matchingItems) {
        const allowedQty = Math.min(
          Number(item.quantity || 0),
          remainingStock
        );
      
        remainingStock -= allowedQty;
      
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: item.key,
            quantity: allowedQty,
          }),
        });
      }
      updateDomQuantity(variantId, stock);
      setPlusButtonState(variantId, stock, stock);
      showStockWarning(
        variantId, stock, stock,
        `Your cart quantity was reduced to ${stock} to match live availability.`
      );
      triggerCartRefresh();
      return { stock, cartQty: stock, source: stockData.source };
    }

    // Normal state
    setPlusButtonState(variantId, stock, cartQty);
    if (cartQty >= stock) {
      showStockWarning(variantId, stock, cartQty);
    } else {
      hideStockWarning(variantId);
    }
    return { stock, cartQty, source: stockData.source };
  }

  // ─── Full cart sync (called after any quantity change) ────────────────────
  async function syncAllVariantStates() {
    beginCartOperation();
    try {
      invalidateCartCache();
      const cart = await fetchCartData();
      if (!cart || !cart.items) return;
const variantTotals = {};
cart.items.forEach(item => {
  const variantId = String(item.variant_id);

  if (!variantTotals[variantId]) {
    variantTotals[variantId] = {
      totalQty: 0,
      items: [],
    };
  }

  variantTotals[variantId].totalQty += Number(item.quantity || 0);
  variantTotals[variantId].items.push(item);
});

const variantIds = Object.keys(variantTotals);
const stockResults = await Promise.all(
  variantIds.map(id => fetchLiveStock(id, { allowFallback: true }))
);
const stockMap = {};
variantIds.forEach((id, i) => { stockMap[id] = stockResults[i]; });
for (const variantId in variantTotals) {
  const variantGroup = variantTotals[variantId];
  const stockData = stockMap[variantId];
  if (!stockData) continue;
  const liveStock = Number(stockData.stock || 0);
  const totalCartQty = Number(variantGroup.totalQty || 0);
  // Quantity exceeds stock
  if (totalCartQty > liveStock) {
    showCheckoutLoader('Cart updated successfully. Please click proceed to checkout', true);
    let remainingStock = liveStock;
    for (const item of variantGroup.items) {
      const allowedQty = Math.min(
        Number(item.quantity || 0),
        remainingStock
      );
      remainingStock -= allowedQty;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: item.key,
          quantity: allowedQty,
        }),
      });
      if (allowedQty === 0) {
        const input = document.querySelector(
          `#updates_${item.variant_id}`
        );
        const cartLine =
          input?.closest('.cart-item') ||
          input?.closest('[class*="cart__item"]') ||
          input?.closest('tr') ||
          input?.closest('li');

        if (cartLine) {
          cartLine.remove();
        }

      } else {

        updateDomQuantity(
          item.variant_id,
          allowedQty
        );

      }
    }

    showStockWarning(
      variantId,
      liveStock,
      totalCartQty,
      `Only ${liveStock} unit${
        liveStock !== 1 ? 's' : ''
      } available. Cart quantity was adjusted.`
    );

  } else {

    if (totalCartQty >= liveStock) {

      showStockWarning(
        variantId,
        liveStock,
        totalCartQty,
        'Your cart already contains the maximum available quantity for this variant.'
      );

    } else {
      hideStockWarning(variantId);
    }
    setPlusButtonState(
      variantId,
      liveStock,
      totalCartQty
    );
  }
}
    } finally {
      endCartOperation();
    }
  }
  // ─── Utility ──────────────────────────────────────────────────────────────
  function extractVariantId(el) {
    if (el.id && el.id.startsWith('updates_')) return el.id.replace('updates_', '');
    const onclick = el.getAttribute('onclick') || '';
    const match = onclick.match(/\d{10,}/);
    return match ? match[0] : null;
  }
  function shouldBlockPlusClick(plusBtn, variantId) {
    return (
      updatingVariants.has(variantId) ||
      plusBtn.getAttribute('data-stock-locked') === 'true' ||
      plusBtn.disabled
    );
  }

  // ─── + Button click ───────────────────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const plusBtn = e.target.closest('.plus.quantity-selector');
    if (!plusBtn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantId = extractVariantId(plusBtn);
    if (!variantId) return;
    if (shouldBlockPlusClick(plusBtn, variantId)) return;
    updatingVariants.add(variantId);
    lockPlusButton(variantId);
    showQuantityLoader(variantId);
    try {
      invalidateCartCache();
      const [stockData, confirmedCartQty] = await Promise.all([
        fetchLiveStock(variantId, { allowFallback: true }),
        getConfirmedCartQuantity(variantId),
      ]);
      if (!stockData) return;
      const stock = stockData.stock;
      if (confirmedCartQty >= stock) {
        showStockWarning(variantId, stock, confirmedCartQty);
        setPlusButtonState(variantId, stock, confirmedCartQty);
        return;
      }
      const newQty = confirmedCartQty + 1;
      if (newQty > stock) {
        showStockWarning(variantId, stock, confirmedCartQty);
        setPlusButtonState(variantId, stock, confirmedCartQty);
        return;
      }
      await onCartUpdate(variantId, newQty);
    } finally {
      updatingVariants.delete(variantId);
      hideQuantityLoader(variantId);
      await syncAllVariantStates(); 
    }
  }, true);

  // ─── − Button click ───────────────────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const minusBtn = e.target.closest('.minus.quantity-selector');
    if (!minusBtn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const variantId = extractVariantId(minusBtn);
    if (!variantId) return;
    if (updatingVariants.has(variantId)) return;
    updatingVariants.add(variantId);
    lockPlusButton(variantId);
    showQuantityLoader(variantId);
    try {
      invalidateCartCache();
      const confirmedCartQty = await getConfirmedCartQuantity(variantId);
      const newQty = Math.max(0, confirmedCartQty - 1);
      hideStockWarning(variantId);
      if (newQty === 0) {
        const item = await getCartItem(variantId);
        if (item) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
          triggerCartRefresh();
          invalidateCartCache();
          const input = document.querySelector(`#updates_${variantId}`);
          const cartLine =
            input?.closest('.cart-item') ||
            input?.closest('[class*="cart__item"]') ||
            input?.closest('tr') ||
            input?.closest('li');
          if (cartLine) cartLine.remove();
        }
      } else {
        await onCartUpdate(variantId, newQty);
      }
    } finally {
      updatingVariants.delete(variantId);
      hideQuantityLoader(variantId);
      await syncAllVariantStates();
    }
  }, true);

  // ─── Prevent double-clicks on +/− ────────────────────────────────────────
  document.addEventListener('dblclick', function (e) {
    if (e.target.closest('.plus.quantity-selector') || e.target.closest('.minus.quantity-selector')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  // ─── Manual input change ──────────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    const input = e.target.closest('input.select-on-focus[id^="updates_"]');
    if (!input) return;
    const variantId = extractVariantId(input);
    if (!variantId) return;
    if (updatingVariants.has(variantId)) return;

    const newQty = parseInt(input.value, 10);
    if (!isNaN(newQty) && newQty >= 0) {
      invalidateCartCache();
      beginCartOperation();
      onCartUpdate(variantId, newQty).then(() => syncAllVariantStates());
    }
  }, true);

  // ─── Checkout click handler ───────────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const checkoutButton = e.target.closest(
      '#checkoutButton, [name="checkout"], .checkout, .cart__checkout-button'
    );
    if (!checkoutButton) return;
    if (cartOperationInProgress) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    beginCartOperation();

    const existingLoader =
      document.getElementById(
        'checkout-stock-loader'
      );
    const alreadyAdjusted =
      existingLoader?.dataset.permanent === 'true';
      if (!alreadyAdjusted) {
        showCheckoutLoader(
          'Checking available stock…'
        );
        setTimeout(() => {
          const loader =
            document.getElementById(
              'checkout-stock-loader'
            );
                if (
            loader &&
            loader.dataset.permanent !== 'true'
          ) {
            hideCheckoutLoader();
          }
        }, 1500);
      }
    try {
      invalidateCartCache();
      const cart = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin',
      }).then(r => r.json());
      if (!cart || !cart.items || !cart.items.length) {
        window.location.href = '/checkout';
        return;
      }
      let anyAdjusted = false;
      const variantTotals = {};
      cart.items.forEach(item => {
        const variantId = String(item.variant_id);
        if (!variantTotals[variantId]) {
          variantTotals[variantId] = {
            totalQty: 0,
            items: [],
          };
        }
        variantTotals[variantId].totalQty += Number(item.quantity || 0);
        variantTotals[variantId].items.push(item);
      });
      const checkoutVariantIds = Object.keys(variantTotals);
      const checkoutStockResults = await Promise.all(
        checkoutVariantIds.map(id => fetchLiveStock(id, { allowFallback: true }))
      );
      const checkoutStockMap = {};
      checkoutVariantIds.forEach((id, i) => { checkoutStockMap[id] = checkoutStockResults[i]; });
      for (const variantId in variantTotals) {
        const variantGroup = variantTotals[variantId];
        const stockData = checkoutStockMap[variantId];
        if (!stockData) continue;
        const liveStock = Number(stockData.stock || 0);
        const totalCartQty = Number(variantGroup.totalQty || 0);
        console.log(
          `Checkout Validation => Variant: ${variantId} | Cart Qty: ${totalCartQty} | Stock: ${liveStock}`
        );
        if (totalCartQty > liveStock) {
          showCheckoutLoader(
            'Cart updated successfully. Please click proceed to checkout.',true
          );
          anyAdjusted = true;
          let remainingStock = liveStock;
          for (const item of variantGroup.items) {
            const allowedQty = Math.min(
              Number(item.quantity || 0),
              remainingStock
            );
            remainingStock -= allowedQty;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                id: item.key,
                quantity: allowedQty,
              }),
            });
            if (allowedQty === 0) {
              const input = document.querySelector(
                `#updates_${item.variant_id}`
              );
          
              const cartLine =
                input?.closest('.cart-item') ||
                input?.closest('[class*="cart__item"]') ||
                input?.closest('tr') ||
                input?.closest('li');
          
              if (cartLine) {
                cartLine.remove();
              }
            } else {
              updateDomQuantity(
                item.variant_id,
                allowedQty
              );
            }
          }
      
          showStockWarning(
            variantId,
            liveStock,
            totalCartQty,
            `Only ${liveStock} unit${
              liveStock !== 1 ? 's' : ''
            } available. Cart quantity was adjusted.`
          );
        } else {
          hideStockWarning(variantId);
      
          setPlusButtonState(
            variantId,
            liveStock,
            totalCartQty
          );
        }
      }
      
      invalidateCartCache();
 
      if (anyAdjusted) {
        triggerCartRefresh();
     
        await updateCartDrawerCount();

        await syncAllVariantStates();
        showCheckoutLoader(
          'Cart updated successfully.Please click proceed to checkout.',true
        );
        return;
      } else {
        hideCheckoutLoader();
        endCartOperation(); 
        window.location.href = '/checkout';
      }
    } catch (err) {
      console.error('Checkout validation error:', err);
      hideCheckoutLoader();
      endCartOperation();
    }
  }, true);

  // ─── Initial sync on page load ────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllVariantStates);
  } else {
    if (window.location.pathname.includes('/cart')) {
      syncAllVariantStates();
    }
  }
})();